import { Typography, Box } from "@material-ui/core"
import React, { useMemo, useState, useEffect } from "react"
import useStyles from "./styles"
import PropTypes from "prop-types"
import EstimateForBox from "./EstimateForBox/index"
import { cleanPhoneNumber } from "../../../../utils/cleanPhoneNumber"
import parseClientCompanyAddress from "../../../../utils/parseClientCompanyAddress"
import fixCompanyAddress from "../../../../utils/fixCompanyAddress"
import useActiveCompanyAdesk from "../../../../hooks/useActiveCompanyAdesk"
import { useDispatch } from "react-redux"
import { updateGeneralDataProperties } from "../../../../actions/billing"
import { openSnackBar } from "../../../../actions/snack-bar"
import SelectOrganizationHeader from "../SelectOrganizationHeader/index"
import AdditionalBillingData from "../../Admin/AdditionalBillingData/index"
import moment from "moment"
import { TextField } from "../../../../../node_modules/@material-ui/core/index"
import { adeskPhones } from "../../../../utils/adeskPhones"

const HeaderByLocation = ({
  headerInfo = {},
  urlMatch = {},
  isDisabled = false,
}) => {
  const dispatch = useDispatch()
  const [selectLoading, setSelectLoading] = useState(false)
  const classes = useStyles()
  //split the window location pathname into an array on the /
  const pathArray = window.location.pathname.split("/")
  const internal = pathArray[pathArray.length - 1] //takes last bit of url, EX: invoice on "/shoots/####/billing/invoice"
  const external = pathArray[1] // takes the name in front of the short_code, EX: estimate on "/estimate/short_code"

  // checking if the url params match /::short_code::
  // if so, means it's an external page (e.g., crew, client viewing)
  const externalUrl = Boolean(urlMatch && urlMatch.short_code)
  const pageValue = externalUrl ? external : internal

  // Additonal Billing Info Value

  const [adBillingValue, setAdBillingValue] = useState("")
  const [loadingAdBilling, setLoadingAdBilling] = useState(false)
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth
  //destructure header info passed in from parent
  const {
    client_name,
    client_phone,
    client_company_name,
    client_company_location,
    company_name,
    representative_name,
    company_phone,
    company_address,
    id,
    shoot_id,
    company_id,
    ad_billing_note,
    company_street,
    company_street_number,
    company_zip,
    company_city,
    company_state,
    start_date,
    crewmama_or_gtt,
  } = headerInfo

  const isAdesk = useActiveCompanyAdesk() || company_id === 2

  const formattedClientAddress = useMemo(
    () => {
      if (client_company_location) {
        return parseClientCompanyAddress(client_company_location)
      }
    },
    [client_company_location]
  )

  const handleChangeCompany = e => {
    setSelectLoading(true)
    let dataObj = { crewmama_or_gtt: e.target.value }
    let shootId = shoot_id || id
    dispatch(updateGeneralDataProperties(dataObj, shootId))
      .then(() => {
        setSelectLoading(false)
        dispatch(openSnackBar({ message: "Updated company name" }))
      })
      .catch(err => {
        console.log(err)
        setSelectLoading(false)
        dispatch(openSnackBar({ message: "Error changing company" }))
      })
  }

  useEffect(
    () => {
      setAdBillingValue(ad_billing_note)
    },
    [ad_billing_note]
  )

  const handelAdBillingChange = e => {
    setAdBillingValue(e.target.value)
  }
  const submitAdBillingInfo = () => {
    setLoadingAdBilling(true)
    let shootId = shoot_id || id

    let dataObj = {
      ad_billing_note: adBillingValue,
    }

    dispatch(updateGeneralDataProperties(dataObj, shootId))
      .then(() => {
        setLoadingAdBilling(false)
        dispatch(openSnackBar({ message: "Updated additional billing info." }))
      })
      .catch(err => {
        console.log(err)
        setLoadingAdBilling(false)
        dispatch(openSnackBar({ message: "Updated additional billing info." }))
      })
  }

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.headerData}>
        <Box className={classes.clientInfo}>
          <Typography className={classes.title}>{pageValue} FOR</Typography>
          <EstimateForBox
            data={client_name}
            label="Client Name"
            phoneLabel="Client"
          />
          <EstimateForBox
            data={cleanPhoneNumber(client_phone)}
            label="Client Phone"
            phoneLabel="Phone"
          />
          <EstimateForBox
            data={client_company_name}
            label="Client Company"
            phoneLabel="Company"
          />
          <EstimateForBox
            data={formattedClientAddress && formattedClientAddress[0]}
            label="Client Address"
            phoneLabel="Address"
          />
          <EstimateForBox
            data={formattedClientAddress && formattedClientAddress[1]}
            label=""
            phoneLabel="Address"
          />
          <Box marginBottom="10px" width="95%">
            {externalUrl ? (
              ad_billing_note !== null && (
                <Box>
                  <Typography
                    align="left"
                    className={classes.subtitle}
                    style={{ marginTop: "20px" }}
                  >
                    {viewportWidth > 600 ? "" : ""}
                  </Typography>
                  <TextField
                    multiline
                    value={ad_billing_note}
                    disabled
                    InputProps={{
                      classes: {
                        root: classes.textField,
                      },

                      disableUnderline: true,
                    }}
                    style={{ width: "100%" }}
                  />
                </Box>
              )
            ) : (
              <>
                <AdditionalBillingData
                  onChange={handelAdBillingChange}
                  adBillingValue={adBillingValue}
                  submitAdBillingInfo={submitAdBillingInfo}
                  loading={loadingAdBilling}
                  boxWidth="100%"
                  disabled={isDisabled}
                />
              </>
            )}
          </Box>
        </Box>
        <Box className={classes.internalInfo}>
          <Typography className={classes.title}>{pageValue} FROM</Typography>
          {/* if estimate or invoice comes from adesk, admin can select which
          company & phone number will show on client side - GTT or Crewmama*/}
          {isAdesk ? (
            <SelectOrganizationHeader
              clientView={externalUrl}
              headerInfo={headerInfo}
              changeCompanyFn={handleChangeCompany}
              working={selectLoading}
            />
          ) : (
            <Typography className={classes.data}>{company_name}</Typography>
            // if not coming from Adesk, show API data for compnay name
          )}
          {company_address && (
            <Typography align="left" className={classes.data}>
              {
                fixCompanyAddress(
                  company_street,
                  company_street_number,
                  company_zip,
                  company_city,
                  company_state
                )[0]
              }
            </Typography>
          )}
          {company_address && (
            <Typography align="left" className={classes.data}>
              {
                fixCompanyAddress(
                  company_street,
                  company_street_number,
                  company_zip,
                  company_city,
                  company_state
                )[1]
              }
            </Typography>
          )}
          {company_phone &&
            (isAdesk ? (
              <Typography align="left" className={classes.data}>
                {cleanPhoneNumber(adeskPhones(crewmama_or_gtt))}
              </Typography>
            ) : (
              <Typography align="left" className={classes.data}>
                {cleanPhoneNumber(company_phone)}
              </Typography>
            ))}
          {representative_name && (
            <Typography align="left" className={classes.data}>
              <span style={{ fontWeight: "bold" }}>Rep: </span>
              {representative_name}
            </Typography>
          )}
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <EstimateForBox data={id || shoot_id} label="ID" phoneLabel="ID" />
        {start_date && (
          <EstimateForBox
            data={moment(start_date).format("M/D/YYYY")}
            label="Shoot Date"
            phoneLabel="Date"
          />
        )}
      </Box>
    </Box>
  )
}

HeaderByLocation.propTypes = {
  headerInfo: PropTypes.object,
  urlMatch: PropTypes.object,
}

export default HeaderByLocation
